module.exports = __webpack_public_path__ + "img/calendar-date-range-picker.bed279b4.svg";